import { useCallback, useEffect, useState } from 'react';

import { applyTheme, nextTheme, readStoredTheme, type ThemeChoice } from '../theme';

const LABEL: Record<ThemeChoice, string> = {
  system: 'system',
  light: 'light',
  dark: 'dark',
};

/** Single button cycling system -> dark -> light. State of record is <html data-theme>. */
export function ThemeToggle(): React.JSX.Element {
  const [choice, setChoice] = useState<ThemeChoice>(() => readStoredTheme(globalThis.localStorage));

  useEffect(() => {
    applyTheme(choice, document.documentElement, globalThis.localStorage);
  }, [choice]);

  const cycle = useCallback(() => {
    setChoice((current) => nextTheme(current));
  }, []);

  return (
    <button type="button" className="dc-theme-toggle" data-testid="theme-toggle" data-theme-choice={choice} aria-label={`Theme: ${LABEL[choice]}`} onClick={cycle}>
      {/* "Theme:" is dropped on a phone (theme.css); the accessible name keeps it everywhere. */}
      <span className="dc-theme-label">Theme: </span>
      {LABEL[choice]}
    </button>
  );
}
